<template>
    <div class="android-model">
        <div class="android-screen">
            <img src="/static/images/android-screen.png" alt="android Screen" class="screen-image" />
            <div class="notification-preview-container">
                <div class="notification-preview">
                    <img src="/static/images/staylio_app_icon.png" alt="Staylio Icon" class="notification-app-icon" />
                    <div class="notification-text">
                        <div class="notification-header">
                            <p class="title" :style="title ? '' : 'color: #999; font-style: italic'">
                                {{ title || 'Preview Title' }}
                            </p>
                        </div>
                        <p class="message" :style="message ? '' : 'color: #999; font-style: italic'">
                            {{ message || 'Preview Message' }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props: {
            title: {
                type: String,
                default: '',
            },
            message: {
                type: String,
                default: '',
            },
        },
        name: 'androidPreview',
        data() {
            return {};
        },
        computed: {},
        mounted() {},
        methods: {},
    };
</script>

<style lang="scss" scoped>
    .android-model {
        width: 100%;
        max-width: 400px;
        height: auto;
        max-height: 880px;
        border: 15px solid black;
        border-radius: 45px;
        position: relative;
        background: #000000;
        margin: 0 auto;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .android-screen {
        width: 100%;
        position: relative;
        overflow: hidden;
        background-color: transparent;
        box-sizing: border-box;
    }

    .screen-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .notification-preview-container {
        position: absolute;
        top: 5%;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        padding: 5px 5px;
    }

    .notification-preview {
        width: 100%;
        background: #f0f0f0;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        padding: 8px;
        border-radius: 0px;
        max-width: 100%;
        box-sizing: border-box;
    }

    .notification-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .notification-app-icon {
        width: 7vw;
        min-width: 15px;
        max-width: 45px;
        height: auto;
        margin: 0.5vw;
        margin-right: 15px;
        background-color: white;
        border-radius: 16px;
        padding: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .notification-text {
        width: calc(100% - 70px);
        word-wrap: break-word;
    }

    .message {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        margin: 0;
    }

    .title {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        margin: 0;
        font-weight: 600;
    }

    /* Media Queries for responsiveness */
    @media (max-width: 600px) {
        .android-model {
            max-width: 300px;
            border: 12px solid black;
            border-radius: 35px;
        }

        .notification-preview-container {
            top: 6%;
        }

        .notification-preview {
            padding: 6px;
        }

        .message {
            font-size: 2.5vw;
            line-height: 2.5vw;
        }

        .title {
            font-size: 2.5vw;
            line-height: 2.5vw;
        }

        .notification-app-icon {
            margin-right: 7px;
        }
    }

    @media (min-width: 600px) and (max-width: 1024px) {
        .android-model {
            max-width: 375px;
        }

        .message {
            font-size: 14px;
            line-height: 16px;
        }

        .title {
            font-size: 14px;
            line-height: 16px;
        }
    }
</style>
